import React, {Component} from 'react';
import {Header} from 'react-adminlte-dash';
import {withRouter} from 'react-router-dom'
import UserService from "../../services/UserService";
import AuthenticationService from "../../services/AuthenticationService";

class UserNav extends Component {

  userService = new UserService();
  authService = new AuthenticationService();

  constructor(props) {
    super(props);
    this.state = {currentUser: props.currentUser};
  }

  render() {
    const {history} = this.props;
    const {currentUser} = this.state;

    return (
        <Header.UserMenu
            name={currentUser.name}
            image="https://www.gravatar.com/avatar/579d29679e3df525833710c0d9039f07?s=84"
            profileAction={() => history.push('/profile')}
            signOutAction={() => {
              this.authService.logout(history);
            }}
            key="2"
        />
    )
  };
}

export default withRouter(UserNav);



// WEBPACK FOOTER //
// ./src/component/Navbar/UserNav.js